"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var layout = {
  desktop1920: 1920,
  desktop1440: 1440,
  desktopLarge: 1200,
  desktop: 1024,
  tablet: 768,
  mobile: 500,
  pageWidth: 1110
};
var _default = layout;
exports["default"] = _default;